import React from "react";
import { useAppSelector } from "../../../hook/redux";
import { isDesktop, toolbarStyles } from "../utils";
import BackgroundSelector from "./Components/BackgroundSelector";
import CornerSelector from "./Components/CornerSelector";
import LayoutSelector from "./Components/LayoutSelector";
import QRCodeButton from "./Components/QRCodeButton";
import SignatureButton from "./Components/SignatureButton";


function LayoutEditor({ canvas }) {
  const { isRounded, isQRCode, isSignature } = useAppSelector((state) => state.editor.currentData.paramGeneral);

  const desktop = isDesktop();




  return (
    <div
      style={ desktop ? toolbarStyles.desktop.container : toolbarStyles.mobile.container }
      className="d-flex mx-0 mx-md-auto bg-white h-md-100"
      data-test="layout-menu-image"
    >
      <div
        style={ desktop ? toolbarStyles.desktop.iconsWrapper : toolbarStyles.mobile.iconsWrapper }
        className="icons-toolbar h-sm-100"
      >
        <LayoutSelector  canvas={ canvas.current } />
        { isRounded && <CornerSelector canvas={ canvas.current } /> }
        <BackgroundSelector />
        { isSignature && <SignatureButton /> }
        { isQRCode && <QRCodeButton /> }
      </div>
    </div>
  );
}

export default LayoutEditor;
